module.exports = __webpack_public_path__ + "img/06.e1dccfd6.jpg";